import { render } from "./WideCard.vue?vue&type=template&id=66ec82ae&scoped=true&ts=true"
import script from "./WideCard.vue?vue&type=script&lang=ts"
export * from "./WideCard.vue?vue&type=script&lang=ts"

import "./WideCard.vue?vue&type=style&index=0&id=66ec82ae&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66ec82ae"]])

export default __exports__